import { css } from '@emotion/react'
import { colors, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

export const mobileView = css`
  ${MQ.NOT_PHONES} {
    display: none;
  }
`

export const contentContainer = css`
  padding: ${spacing(2)} ${spacing(2)} ${spacing(15)} ${spacing(2)};
  background-color: ${colors.black100};
  min-height: calc(100vh - 120px); /* Account for header and bottom nav */
  margin-top: 140px; /* Space for fixed header */
`

export const cardsContainer = css`
  display: flex;
  flex-direction: column;
  margin-bottom: ${spacing(4)};
`

export const inwinsCardsContainer = css`
  margin-bottom: ${spacing(8)};
`

export const loadingMore = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing(2)};
`

export const loadingPlaceholder = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 40px;
`

export const emptyState = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing(4)};
  text-align: center;
`
